import ProgressContainer from "../../../Components/UiKits/Progress/ProgressContainer";

const ProgressBar = () => {
  return <ProgressContainer />;
};

export default ProgressBar;
